import type { IDotKeyValueData } from './dotcms-dotkeyvalue';

export type IDotcmsItemRestrictedBasedOnCountryJurisdiction = {
  countryAllowList: ReadonlyArray<string>;
  countryBlockList: ReadonlyArray<string>;
};

export const processAllowOrBlockList = (
  list: ReadonlyArray<IDotKeyValueData> | undefined,
): ReadonlyArray<string> => (list ? list.map(({ key }) => key) : []);
